<template>
    <a-modal :title="`改变上门取货时间`" :width="800" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="快递单号">
                    {{ state.logistics.order_number }}<br />
                    {{ state.logistics.out_trade_no }}
                </a-form-item>
                <a-form-item label="上门取货时间" required>
                    <a-date-picker v-model:value="formData.timing_time" :format="format" show-time />
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'

const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    //快递单号的 我们系统单号
    order_number: {
        type: String,
        default: ''
    },
    customer_id: {
        type: Number,
        default: 0
    }
})
interface IState {
    loading: boolean
    submitLoading: boolean
    logistics: any
}
const state = reactive<IState>({
    loading: false,
    submitLoading: false,
    logistics: {}
})
interface IformData {
    timing_time: any
}
const formData = reactive<IformData>({
    timing_time: null,
})
onMounted(() => {
    getLogInfo()
})
// 获取邮寄的快递单号信息
const getLogInfo = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/LogisticsLog/info',
        method: 'post',
        data: { order_number: props.order_number }
    }
    baseService(requestParam)
        .then((res) => {
            state.logistics = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('查询失败,请联系管理员')
            }
        }).finally(() => {
            state.loading = false
        })
}
// 提交
const onFormSubmit = () => {
    state.submitLoading = true
    ruleForm.value
        .validate()
        .then((res) => {
            let requeryParam = {
                url: '/admin/v1/LogisticsLog/changeTimingTime',
                method: 'post',
                data: {
                    timing_time: dayjs(formData.timing_time, format),
                    id: state.logistics.id,
                    customer_id: props.customer_id
                }
            }
            baseService(requeryParam)
                .then((res: any) => {
                    message.success(res.msg)
                    emit('ok')
                    state.submitLoading = false
                })
                .catch((res) => {
                    state.submitLoading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                }).finally(() => {
                    state.submitLoading = false
                })
        })
        .catch((res) => {
            state.submitLoading = false
            message.warn('请检查必填项')
        })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
